import moment from 'moment';
import { MODAL_STATES } from 'food-benefit.module/common/domain/constants';
import { FOOD_BENEFIT_STATES } from  'common/domain/constants';

const PERMISSION = {
  USER: 'R',
};

class myFoodBenefitHelper {

  constructor($translate, foodDelegationService) {
    'ngInject';
    this.translate = $translate;
    this.foodDelegationService = foodDelegationService;
  }

  getApproveAllMessage() {
    return this.translate('FOOD_BENEFIT.MODAL_APPROVE_ALL.OK').then((translation) => {
      return translation;
    });
  }

  getEmployeeToFilter(employee) {
    return {
      employeeId: employee.profile.userId || employee.profile.employeeId,
      name: employee.profile.name,
    };
  }

  findDelegation(delegationsObject) {
    const today = moment().format('YYYY-MM-DD');
    let delegation = this.foodDelegationService
                        .findDelegationActive(today, delegationsObject, PERMISSION.USER);
    return delegation;
  }
  
  getOwnEmployee(employees, userId) {
    let ownEmployee = [];
    employees.forEach((employeeData) => {
      let currentEmployeeId = employeeData.profile.userId;
      if(currentEmployeeId === userId)
        ownEmployee.push(employeeData);
    });
    return ownEmployee;
  }
  
  getDelegatedEmployees(employees, userId) {
    let delegatedEmployees = [];
    employees.forEach((employeeData) => {
      let currentEmployeeId = employeeData.profile.userId;
      if(currentEmployeeId !== userId)
        delegatedEmployees.push(employeeData);
    });
    return delegatedEmployees;
  }

  getModalStateSendAll() {
    return MODAL_STATES.isSendingAllCards;
  }

  checkMoreThanOneModified(modifiedArray) {
    return (modifiedArray.length > 1);
  }

  formatRequest(card) {
    return {
      employeeId: card.id,
      enjoymentDays: card.enjoymentDays,
      enjoymentMonth: card.enjoymentMonth,
      enjoymentYear: card.enjoymentYear,
    };
  }

  getModalStateFailed() {
    return MODAL_STATES.failed;
  }

  getModalStateApproved() {
    return MODAL_STATES.approve;
  }

  getFloatingSendAllButton() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.SEND_ALL'
      }
    ];
  }

  setCardStateApproved(card, employees) {
    let newCard = this.findCard(card, employees);
    let newCardState = newCard.state;
    newCard.state = FOOD_BENEFIT_STATES.success;
    return newCardState;
  }

  setCardStateFailed(card, employees) {
    let newCard = this.findCard(card, employees);
    let newCardState = FOOD_BENEFIT_STATES.error;
    newCard.requestErrorMsg = card.requestErrorMsg;
    newCard.state = FOOD_BENEFIT_STATES.error;
    return newCardState;
  }

  findCard(card, employees) {
    let newCard = undefined;
    employees.forEach((employee) => {
      if (newCard) return;
      newCard = employee.cards.find((searchCard) => {
        return card.id === searchCard.id && card.enjoymentMonth === searchCard.enjoymentMonth;
      });
    });
    return newCard;
  }

}

export default myFoodBenefitHelper;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/services/myFoodBenefitHelper.service.js